import React from 'react'
import PropTypes from 'prop-types'

const renderIconComponent = (iconClassName, iconComponent) => {
  if (iconComponent){
    return iconComponent
  }

  return (
    <i className={iconClassName} />
  )
}

const InfoIcon = ({ className, description, iconClassName, iconComponent, infoClassName }) => (
  <span className={className}>
    {renderIconComponent(iconClassName, iconComponent)}
    <div className={infoClassName}>{description}</div>
  </span>
)

InfoIcon.propTypes = {
  className: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  iconClassName: PropTypes.string,
  iconComponent: PropTypes.node,
  infoClassName: PropTypes.string,
}

InfoIcon.defaultProps = {
  className: 'heading-info-icon',
  iconClassName: 'icon fi-info',
  infoClassName: 'info',
}

export default InfoIcon
